import {HTTP} from '@/services/http-common'
import * as types from '../mutation-types'

// initial state
const state = {
    // email marketing provider
    contactLists: [],
    primaryContactList: null
}

// getters
const getters = {
    // email marketing provider
    contactLists: state => state.contactLists,
    primaryContactList: state => state.primaryContactList
}

// actions
const actions = {
    // email marketing provider
    async getContactLists({ commit, rootState }, params) {
        // fetch available contact lists from /api/businesses/{businessId}/integrations/email_marketing/lists
        const businessId = rootState.business?.business?.id || null
        const service = params.service
        try {
            const response = await HTTP.get(`/businesses/${businessId}/integrations/${service}/lists`)
            commit(types.SET_CONTACT_LISTS, response.data.lists)
        } catch (error) {
            console.error('Error fetching contact lists:', error)
            commit(types.SET_CONTACT_LISTS, [])
        }
    },
    async putPrimaryContactList({ commit, rootState }, params) {
        // save primary contact list to /api/businesses/{businessId}/integrations/{service}/primary-list
        const businessId = rootState.business?.business?.id || null
        const service = params.service
        const listId = params.listId
        try {
            await HTTP.put(`/businesses/${businessId}/integrations/${service}/primary-list`, { listId: listId })
            commit(types.SET_PRIMARY_CONTACT_LIST, listId)
        } catch (error) {
            console.error('Error saving primary contact list:', error)
        }
    },

    async syncEmailMarketingMembers({ rootState }, params) {
        const businessId = rootState.business?.business?.id || null
        const service = params.service
        try {
            await HTTP.post(`/businesses/${businessId}/service_apis/${service}/sync_members`)
        } catch (error) {
            console.error('Error syncing members:', error)
        }
    }
}

// mutations
const mutations = {
    // email marketing provider
    [types.SET_CONTACT_LISTS](state, contactLists) {
        state.contactLists = contactLists;
        // set primary list 
        const primaryList = contactLists.find(list => list.is_primary);
        state.primaryContactList = primaryList ? primaryList.id : null;
    },
    [types.SET_PRIMARY_CONTACT_LIST](state, listId) {
        state.primaryContactList = listId;
    }
}

export default {

  state,
  getters,
  actions,
  mutations
}